import { useState, useEffect } from 'react'
import { getSession, signOut as ncbSignOut } from '../api'

export const useSimpleAuth = () => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setUser(getSession())
    setLoading(false)

    const handleAuthStateChange = () => {
      setUser(getSession())
    }
    
    window.addEventListener('auth-state-change', handleAuthStateChange)
    
    return () => {
      window.removeEventListener('auth-state-change', handleAuthStateChange)
    }
  }, [])

  const signOut = async () => {
    ncbSignOut()
    setUser(null)
    window.dispatchEvent(new Event('auth-state-change'))
  }

  return { user, loading, signOut }
}